import { apiHolder, apis } from 'api';
const trackerApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
class ContactTracker {
    constructor() {
        this.tracker = (...args) => {
            try {
                trackerApi.track.call(trackerApi, ...args);
            }
            catch (error) { }
        };
        this.tracker_contact_search_input = () => {
            this.tracker('pcContact_input_searchContent_searchInputBox');
        };
        this.tracker_contact_search_focus = () => {
            this.tracker('pcContact_click_searchInputBox_topBar');
        };
        this.tracker_contact_view_detail = () => {
            this.tracker('pcContact_view_contactsDetailPage');
        };
        this.tracker_contact_detail_click = (buttonName, pageType) => {
            this.tracker('pcContact_click_button_contactsDetailPage', {
                buttonName,
                pageType: pageType || '',
            });
        };
        this.tracker_mail_list_save_click = (saveStatus) => {
            this.tracker('pcContact_click_save_addOrEditMailGroupListPage', {
                saveStatus,
            });
        };
        this.tracker_mail_list_top_click = (buttonName) => {
            this.tracker('pcContact_click_topButton_mailGroupList', {
                buttonName,
            });
        };
        this.tracker_mail_list_view = (permission) => {
            this.tracker('pcContact_view_mailGroupList', {
                permission,
            });
        };
        this.tracker_contact_list_click = (fromContact) => {
            this.tracker('pcContact_click_contacts_contactsList', { fromContact });
        };
        this.tracker_contact_add_click = () => {
            this.tracker('pcContact_click_addNewContacts');
        };
        this.tracker_contact_personal_mark_add = (source) => {
            this.tracker('pcMail_click_addStarContact', { source });
        };
        this.tracker_contact_personal_mark_startIcon_click = (source, marked) => {
            this.tracker('pcMail_click_starIcon', { source, result: marked ? '添加星标' : '取消星标' });
        };
        this.tracker_contact_save_click = (params) => {
            this.tracker('pcContact_click_complete_addContactsPage', params);
        };
        this.tracker_contact_import_save_click = (params) => {
            this.tracker('pcContact_click_confirm_importContactsPage', params);
        };
        this.tracker_contact_export_click = (params) => {
            this.tracker('pcContact_click_confirm_exportContactsPage', params);
        };
    }
}
const ContactTrackerIns = new ContactTracker();
export default ContactTrackerIns;
